import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var WheelchairSvg = function WheelchairSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.615 3.135a3.08 3.08 0 0 1 2.163-.886c.81 0 1.589.319 2.162.886.574.566.896 1.335.896 2.137s-.322 1.571-.896 2.138a3.08 3.08 0 0 1-2.162.886c-.811 0-1.59-.319-2.163-.886a3 3 0 0 1-.896-2.138c0-.802.323-1.57.896-2.137m2.163.51c-.437 0-.856.17-1.165.476a1.62 1.62 0 0 0 0 2.302 1.657 1.657 0 0 0 2.33 0 1.62 1.62 0 0 0 0-2.302 1.66 1.66 0 0 0-1.165-.477",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.661 12.947c-.791 0-1.564.232-2.222.666a3.96 3.96 0 0 0-1.473 1.774 3.9 3.9 0 0 0-.228 2.285 3.94 3.94 0 0 0 1.095 2.024c.56.553 1.272.93 2.048 1.082s1.58.074 2.31-.225c.731-.3 1.356-.806 1.795-1.456a3.9 3.9 0 0 0 .674-2.197h1.412a5.3 5.3 0 0 1-.912 2.972 5.4 5.4 0 0 1-2.428 1.97 5.47 5.47 0 0 1-3.127.304 5.43 5.43 0 0 1-2.77-1.464 5.33 5.33 0 0 1-1.481-2.738 5.3 5.3 0 0 1 .308-3.09 5.36 5.36 0 0 1 1.993-2.401 5.46 5.46 0 0 1 3.006-.902z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.837 9.543a6.78 6.78 0 0 0-3.94-1.247 6.78 6.78 0 0 0-3.941 1.247l.823 1.133a5.35 5.35 0 0 1 3.115-.985h.005a5.36 5.36 0 0 1 2.665.699l-2.042 5.347h6.135l1.736 6.006 1.357-.383-2.028-7.018h-5.158l1.713-4.487z"
  }));
};
export var Wheelchair = function Wheelchair(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: WheelchairSvg
  }));
};